import { combineReducers } from "redux";

import { clienteController } from "../modulos/cliente/cliente.controll";
import { fornecedorController } from "../modulos/fornecedor/forn.controll";
import { funcionarioController } from "../modulos/funcionario/funcionario.controll";
import { meioPagController } from "../modulos/meioPag/meiopg.controll";
import { itemController } from "../modulos/item/item.controll";
import { configController } from "../modulos/config/config.controll";
import { tipoMovController } from "../modulos/tipoMov/tipomov.controll";
import { movController } from "../modulos/movimentacoes/mov.controll";
import { canalDistController } from "../modulos/canalDist/canalDist.controll";
import { contasController } from "../modulos/contas/contas.controll";
import { estoqueController } from "../modulos/estoque/estoque.controll";
import { tabelaPrecoController } from "../modulos/settings/tabelaPreco/tabpreco.controll";
import { convenioController } from "../modulos/settings/convenio/convenio.controll";
import { galeriaController } from "../modulos/galeria/galeria.controll";

const clienteState = clienteController.reducer.reduceState
const fornecedorState = fornecedorController.reducer.reduceState
const funcionarioState = funcionarioController.reducer.reduceState
const meioPagState = meioPagController.reducer.reduceState
const itemState = itemController.reducer.reduceState
const configState = configController.reducer.reduceState
const tipoMovState = tipoMovController.reducer.reduceState
const movState = movController.reducer.reduceState
const canalDistribuicaoState = canalDistController.reducer.reduceState
const contasState = contasController.reducer.reduceState
const estoqueState = estoqueController.reducer.reduceState
const tabelaPrecoState = tabelaPrecoController.reducer.reduceState
const convenioState = convenioController.reducer.reduceState
const galeriaState = galeriaController.reducer.reduceState


export default combineReducers({
    clienteState,
    fornecedorState,
    funcionarioState,
    meioPagState,
    itemState,
    configState,
    tipoMovState,
    movState,
    canalDistribuicaoState,
    contasState,
    estoqueState,
    tabelaPrecoState,
    convenioState,
    galeriaState
});